/**
 * UI-only icon lookup for the asset/liability type ids defined in
 * shared/src/calculation/constants/assetTypes.ts. That module is deliberately data-only (no
 * lucide-react dependency, since it's shared with the server) — this is where the frontend
 * attaches an icon per id for display (e.g. the Assets/Liabilities step legends).
 */
import type { LucideIcon } from 'lucide-react';
import { Landmark, Banknote, Building, TrendingUp, Wallet, HandCoins, ShieldCheck, Car, PlusCircle, Home, User, CreditCard, HousePlus, Gem, Landmark as LandmarkIcon, Flower2, Handshake } from 'lucide-react';

export const ASSET_TYPE_ICONS: Record<string, LucideIcon> = {
    bankAccounts: Landmark,
    termDeposits: Banknote,
    investmentProperty: Building,
    shares: TrendingUp,
    investmentBonds: Gem,
    superannuation: Wallet,
    accountBasedPensions: HandCoins,
    annuities: HandCoins,
    funeralBonds: ShieldCheck,
    prepaidFuneral: Flower2,
    loansToOthers: Handshake,
    personalAssets: Car,
    other: PlusCircle,
};

/**
 * EVERY id in LIABILITY_TYPES needs an entry. The Liabilities step renders `<type.icon />` directly,
 * so a missing icon is not a cosmetic gap — it throws the moment a client records a liability of
 * that kind, taking the step down with it.
 */
export const LIABILITY_TYPE_ICONS: Record<string, LucideIcon> = {
    mortgages: Home,
    personalLoans: User,
    creditCards: CreditCard,
    reverseMortgages: HousePlus,
    homeEquityAccessScheme: LandmarkIcon,
};
